import { fetcher, SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  ExemptionCertificate,
  ExemptionCertificateFileGetResponse,
} from './types';

export function getExemptionCertificate({
  certificateId,
  corporation_id,
}: {
  certificateId: string;
  corporation_id: number;
}) {
  const { data, error, isLoading, mutate } = useSWR<{
    data: ExemptionCertificate;
  }>(
    certificateId
      ? `new-sales-tax/exemption-certificates/${certificateId}?corporation_id=${corporation_id}`
      : null,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    certificate: data?.data,
    isLoading,
    error,
    mutate,
  };
}

export async function getExemptionCertificateFile(
  fileId: string,
  corporation_id: number
): Promise<{
  success: boolean;
  data?: ExemptionCertificateFileGetResponse;
  error?: string;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/exemption-certificates/file/${fileId}?corporation_id=${corporation_id}`,
      {
        method: 'GET',
      },
      undefined
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to get exemption certificate file',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}
